import { update } from "lodash";

const profileActions = {
  FETCH_PROFILE_DATA_START: 'FETCH_PROFILE_DATA_START',
  FETCH_PROFILE_DATA_UPDATE: 'FETCH_PROFILE_DATA_UPDATE',
  FETCH_PROFILE_DATA_SUCCESS: 'FETCH_PROFILE_DATA_SUCCESS',
  FETCH_PROFILE_DATA_FAILURE: 'FETCH_PROFILE_DATA_FAILURE',
  PROFILE_EMPRESAS: 'PROFILE_EMPRESAS',
  SET_PROFILE_DATA: 'SET_PROFILE_DATA',
  GET_NOTIFICACIONES: 'GET_NOTIFICACIONES',
  SET_NOTIFICACIONES: 'SET_NOTIFICACIONES',
  UPDATE_NOTIFICACIONES: 'UPDATE_NOTIFICACIONES',
  fetchProfileDataStart: () => ({
    type: profileActions.FETCH_PROFILE_DATA_START,
  }),
  fetchProfileDataSuccess: profile => ({
    type: profileActions.FETCH_PROFILE_DATA_SUCCESS,
    payload: profile,
  }),
  fetchProfileDataUpdate: profile => ({
    type: profileActions.FETCH_PROFILE_DATA_UPDATE,
    payload: profile,
  }),
  fetchProfileDataFailure: error => ({
    type: profileActions.FETCH_PROFILE_DATA_FAILURE,
    payload: error,
  }),
  fetchNotificaciones: (payload) => ({
    type: profileActions.GET_NOTIFICACIONES,
    payload,
  }),
  updateNotificaciones: (payload) => ({
    type: profileActions.UPDATE_NOTIFICACIONES,
    payload,
  }),
};

export default profileActions;
